





























































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import PointerMenu from "./PointerMenu.vue";
import Loading from "./Loading.vue";
import CategoryTypeSelect from "./CategoryTypeSelect.vue";

import SettingsJson from "../../shared/SettingsJson";
import PriceTemplateJson, { getPriceJsonFromTemplateJson } from "../../shared/PriceTemplateJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import PriceJson, { PriceBookingJson } from "../../shared/PriceJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import PriceTemplates from "../custom/PriceTemplates";

type keysForCachedPrices = {
  [key in keyof Pick<
    PriceJson,
    | "priceDeposit"
    | "priceDepositAdditionalParticipant"
    | "priceNonDeposit"
    | "priceNonDepositAdditionalParticipant"
    | "cancellationFee"
  >]: string;
};

export default Vue.extend({
  name: "FormPrice",
  components: {
    PointerMenu,
    Loading,
    CategoryTypeSelect,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    data: Object as PropType<PriceJson | PriceBookingJson>,
    editable: Boolean,
    hideInputs: {
      type: Array,
      default() {
        return ["priceDepositIncludedVATRate", "priceNonDepositIncludedVATRate", "cancellationFeeIncludedVATRate"];
      },
    },
    requiredInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    customId: {
      default: "0",
    },
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      UserPermissionRank: UserPermissionRank,
      CategoryTypeType: CategoryTypeType,
      allPriceTemplates: null as PriceTemplateJson[] | null,
      categoryTypes: null as CategoryTypeJson[] | null,
      details: null as PriceJson | PriceBookingJson | null,
      selectedPriceTemplate: {} as PriceTemplateJson,
      cachedPrices: null as keysForCachedPrices | null,
      selectedDeletedPriceRestrictToTypes: [] as CategoryTypeJson[],
      toValidate: {} as any,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.setCachedData();
  },
  methods: {
    init() {
      this.details = { ...this.data };
      this.setCachedData();

      this.loadPriceTemplates();
      this.loadCategoryTypes();
    },

    setCachedData() {
      this.setCachedPrices();
    },

    async loadPriceTemplates() {
      this.allPriceTemplates = null;

      try {
        this.allPriceTemplates = await this.restClient.getPriceTemplates();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadCategoryTypes() {
      this.categoryTypes = null;

      try {
        this.categoryTypes = await this.restClient.getCategoryTypes();

        this.filterDeletedPriceRestrictToTypes();
      } catch (e) {
        alert(e.message);
      }
    },

    selectPriceTemplate() {
      if (this.details != null && this.selectedPriceTemplate != null) {
        this.details = getPriceJsonFromTemplateJson(this.selectedPriceTemplate);

        this.setCachedPrices();
      }
    },

    //START set cached data

    setCachedPrices() {
      if (this.details != null) {
        let prices = {
          cancellationFee: "0,00",
          priceDeposit: "0,00",
          priceDepositAdditionalParticipant: "0,00",
          priceNonDeposit: "0,00",
          priceNonDepositAdditionalParticipant: "0,00",
        } as keysForCachedPrices;

        let k = prices;
        let i: keyof typeof k;

        for (i in prices) {
          prices[i] = this.getFormatPrice(this.details[i]);
        }

        this.cachedPrices = prices;
      }
    },

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "price", key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    formatAndSetCachedPrice(key: keyof keysForCachedPrices) {
      if (this.details != null && this.cachedPrices != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.details[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data (where data be cached)

    filterDeletedPriceRestrictToTypes() {
      if (this.details != null && "restrictToTypes" in this.details) {
        var filteredDeletedRestrictToTypes: CategoryTypeJson[] = [];

        if (this.categoryTypes != null && this.details.restrictToTypes != null) {
          filteredDeletedRestrictToTypes = this.details.restrictToTypes.filter(
            (pt: CategoryTypeJson) => !this.categoryTypes!.map((ct: CategoryTypeJson) => ct.ID).includes(pt.ID)
          );
        }

        this.selectedDeletedPriceRestrictToTypes = [...filteredDeletedRestrictToTypes];
      }
    },

    checkHideInput(inputs: string[]) {
      return !inputs.some((i) => !this.hideInputs.includes(i));
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    data: function () {
      this.details = this.data;
      this.setCachedData();
    },

    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.$emit("change", this.details);
        }
      },
      deep: true,
    },

    /* submitValidation: function () {
      if (this.submitValidation) {
        if (this.details != null) {
          this.validation = validateSepaMandate(this.details);
        }
      }
    }, */
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    restrictToTypes: {
      get(): CategoryTypeJson[] | undefined {
        if (this.details != null && "restrictToTypes" in this.details) {
          if (this.details.restrictToTypes == null) {
            return [];
          } else {
            return this.details.restrictToTypes;
          }
        }
      },
      set(value: CategoryTypeJson[]) {
        if (this.details != null && "restrictToTypes" in this.details) {
          if (value.length <= 0) {
            this.details.restrictToTypes = null;
          } else {
            this.details.restrictToTypes = value;
          }
        }
      },
    },

    parsePriceDepositParticipantCount: {
      get(): number | null | undefined {
        if (this.details != null) {
          return this.details.priceDepositParticipantCount;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.priceDepositParticipantCount = null;
          } else {
            this.details.priceDepositParticipantCount = parseInt(value);
          }
        }
      },
    },

    parsePriceNonDepositParticipantCount: {
      get(): number | null | undefined {
        if (this.details != null) {
          return this.details.priceNonDepositParticipantCount;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.priceNonDepositParticipantCount = null;
          } else {
            this.details.priceNonDepositParticipantCount = parseInt(value);
          }
        }
      },
    },
  },
});
